<template>
  <!-- <SkeletonReport /> -->

  <div>
    <!-- <TableControlsSkeleton class="form selectors" width="200px" v-if="countLoading < countControlsLoading" /> -->
      <!-- v-show="countLoading > countControlsLoading - 1" -->
    <a-form
      ref="formRef"
      class="form selectors"
      :model="formState"
      :rules="rules"
      layout="vertical"
    >
      <a-form-item v-if="showEntity" label="Empresa" name="entity">
        <entity-picker :value="formState.entity" @update:value="formState.entity = $event" @finishLoading="countLoading++" />
      </a-form-item>
      <a-form-item label="Campaña" name="campaign">
        <campaign-picker
          :showAll="false"
          :value="formState.campaign"
          @update:value="formState.campaign = $event"
          :entity="formState.entity"
        />
      </a-form-item>
      <a-form-item v-if="showBases" label="Base" name="base">
        <bases-picker
          :value="formState.base"
          @update:value="formState.base = $event"
          :entity="formState.entity"
          :portfolio="formState.campaign"
          @finishLoading="countLoading++"
        />
      </a-form-item>
      <a-form-item label="Usuarios" name="user">
        <selector-users v-model:value="formState.user" @onSelected="handleChange"  @finishLoading="countLoading++" />
      </a-form-item>
      <a-form-item label="Fecha" name="date">
        <a-date-picker
          v-model:value="formState.date"
          format="DD/MM/YYYY"
          valueFormat="YYYY-MM-DD"
          :disabled-date="disabledDate"
          placeholder="-- / -- / ----"
          @change="handleOpenChange"
        />
      </a-form-item>
      <a-form-item label="Hora de inicio" name="timeStart">
        <a-time-picker :showNow="false" v-model:value="formState.timeStart" format="HH:mm" />
      </a-form-item>
      <a-form-item label="Hora de fin" name="timeEnd">
        <a-time-picker :showNow="false" v-model:value="formState.timeEnd" format="HH:mm" />
      </a-form-item>
      <div v-if="!user?.customer?.type_business == 1"></div>
      <div v-if="!user?.customer?.enable_bases"></div>

      <div class="back-base" v-if="user?.customer?.enable_bases">
        <div v-if="countReport > -1" class="totalReport__wrapper">
          <span class="totalReport">{{ countReport }} Registros</span>
        </div>

        <a-button type="primary" :disabled="!isDisabled || loadingChart || loadingTable" :loading="loadingChart || loadingTable" @click="handleSearch">
          Buscar
          <SearchOutlined />
        </a-button>
        <a-tooltip placement="bottom">
          <template #title>
            <span v-if="isGlobalDownloading"> Hay una descarga pendiente </span>
            <span v-else>
              Se descargarán únicamente los datos de la tabla de acuerdo a los filtros
              seleccionados.
            </span>
          </template>
          <a-button
            type="link"
            :disabled="!isDisabled || isGlobalDownloading"
            :loading="isLoading"
            @click="handleDownload"
            class="button__download"
          >
            Descargar
            <DownloadOutlined />
          </a-button>
        </a-tooltip>
      </div>
      <div class="back" :class="isHideBase ? 'flex' : ''" v-else>
        <div v-if="countReport > -1" class="totalReport__wrapper">
          <span class="totalReport">{{ countReport }} Registros</span>
        </div>

        <div class="download" :class="isHideBase ? 'buttonDownload' : ''">
          <a-tooltip :title="isGlobalDownloading ? 'Tiene una descarga pendiente' : null">
            <a-button
              type="link"
              :disabled="!isDisabled || isGlobalDownloading"
              :loading="isLoading"
              @click="handleDownload"
              class="button__download"
            >
              Descargar
              <DownloadOutlined />
            </a-button>
          </a-tooltip>
        </div>
        <a-button type="primary" :disabled="!isDisabled || loadingChart || loadingTable" :loading="loadingChart || loadingTable" @click="handleSearch">
          Buscar
          <SearchOutlined />
        </a-button>
      </div>
    </a-form>

    <CustomScrollbar height="calc(100vh - 375px)">
      <!-- <a-card
        class="chart-placeholder"
        :bordered="false"
        :body-style="{ padding: '0', margin: '10px 0' }"
        v-if="loadingChart || !data || countLoading < countControlsLoading"
      >
        <div class="gray-card" />
      </a-card> -->
       <!-- v-else-if="data" -->
      <div>
        <line-chart-user :data="data" :user="userSelected" />
      </div>

      <!-- <TableSkeleton v-if="loadingTable || countLoading < countControlsLoading" style="margin-top: 10px" :rows="2" /> -->
      <!-- <div v-else> -->
      <a-table
        size="middle"
        :columns="columnsTable"
        :data-source="dataTable"
        :scroll="{ x: 1000 }"
      >
        <template #userTitle>
          Usuario
          <a-tooltip>
            <template #title> Ordenar </template>
            <SwapOutlined :rotate="90" />
          </a-tooltip>
        </template>
        <template #hourTitle>
          Hora
          <a-tooltip>
            <template #title> Ordenar </template>
            <SwapOutlined :rotate="90" />
          </a-tooltip>
        </template>
        <template #hourManagement="{ text }">
          {{ text + ":00 a " + (parseInt(text) + 1) + ":00" }}
        </template>
      </a-table>
      <!-- </div> -->
    </CustomScrollbar>
  </div>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import SelectorUsers from "@/app/shared/components/selectors/SelectorUsers.vue";
import BasesPicker from "@/app/shared/components/pickers/BasesPicker.vue";
import { DownloadOutlined, SearchOutlined, SwapOutlined } from "@ant-design/icons-vue";
import { defineComponent, ref, computed, watch, reactive, toRaw } from "vue";
import dayjs from "dayjs";
import { useStore } from "vuex";
import { dateToString } from "@/app/shared/utils/dates";
import {
  fetchTypificationsByHour,
  downloadReportTypificationsByHour,
} from "@/app/reports/services";
import { columnsTypificationsByHour } from "@/app/reports/utils/constants";
import { columnsFixedTableLeft } from "@/app/shared/utils/columnTable";
import LineChartUser from "@/app/reports/components/charts/lineChartUser.vue";
import moment from "moment";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import TableControlsSkeleton from "@/app/shared/components/skeletons/TableControlsSkeleton.vue";
import TableSkeleton from "@/app/shared/components/skeletons/TableSkeleton.vue";
// import SkeletonReport from "./Skeletons/SkeletonReport.vue";

export default defineComponent({
  components: {
    CustomScrollbar,
    EntityPicker,
    CampaignPicker,
    BasesPicker,
    DownloadOutlined,
    SearchOutlined,
    LineChartUser,
    SelectorUsers,
    SwapOutlined,
    // SkeletonReport,
    TableControlsSkeleton,
    TableSkeleton,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const userSelected = ref(null);
    const endOpen = ref(false);
    const isLoading = ref(false);
    const formRef = ref();
    const data = ref([]);
    const countReport = ref(undefined);
    const dataTable = ref([]);
    const countLoading = ref(0);
    const loadingChart = ref(false);
    const loadingTable = ref(false);

    const { isGlobalDownloading } = useGlobalDownloadState();
    // const todayDate = moment().format("YYYY-MM-DD");
    // const timeStart = moment("00:00").format("HH:mm");
    // const timeEnd = moment(store.getters["getHourPlatform"]).format("HH.mm");

    const formState = reactive({
      entity: undefined,
      campaign: undefined,
      base: undefined,
      date: null,
      timeStart: null,
      timeEnd: null,
      user: undefined,
    });
    const rules = {
      entity: [{ required: user.value?.customer?.type_business == 1, message: "Campo requerido" }],
      campaign: [{ required: true, message: "Campo requerido" }],
      base: [{ required: user.value?.customer?.enable_bases, message: "Campo requerido" }],
      date: [{ required: true, message: "Campo requerido" }],
      timeStart: [{ required: true, message: "Campo requerido" }],
      timeEnd: [{ required: true, message: "Campo requerido" }],
      user: [],
    };

    const showEntity = computed(() => {
      return user.value?.customer?.type_business == 1;
    });

    const showBases = computed(() => {
      return user.value?.customer?.enable_bases;
    })

    const countControlsLoading = computed(() => {
      return (showEntity.value ? 1 : 0) +
        (showBases.value ? 1 : 0) +
        1 // combo usuarios
    })

    const isDisabled = computed(() => {
      const hasValidHourRange = formState.timeStart && formState.timeEnd;

      if (formState.entity === 0) return hasValidHourRange;

      return (
        hasValidHourRange &&
        formState.date &&
        formState.campaign &&
        (formState.entity !== undefined || !user.value?.customer?.type_business == 1) &&
        (formState.base !== undefined || !user.value?.customer?.enable_bases)
      );
    });

    const columnsTable = computed(() => columnsFixedTableLeft(columnsTypificationsByHour));

    const handleDownload = async () => {
      isLoading.value = true;
      await downloadReportTypificationsByHour({
        entity: toRaw(formState).entity,
        campaign: toRaw(formState).campaign,
        base: toRaw(formState).base,
        timeStart:
          dateToString(toRaw(formState).date, "yyyy-MM-DD") +
          " " +
          toRaw(formState).timeStart.format("HH:mm"),
        timeEnd:
          dateToString(toRaw(formState).date, "yyyy-MM-DD") +
          " " +
          toRaw(formState).timeEnd.format("HH:mm"),
        user: toRaw(formState).user,
      });
      isLoading.value = false;
    };

    const searchChart = async () => {
      loadingChart.value = true;
      data.value = await fetchTypificationsByHour({
        entity: toRaw(formState).entity,
        campaign: toRaw(formState).campaign,
        base: toRaw(formState).base,
        timeStart:
          dateToString(toRaw(formState).date, "yyyy-MM-DD") +
          " " +
          toRaw(formState).timeStart.format("HH:mm"),
        timeEnd:
          dateToString(toRaw(formState).date, "yyyy-MM-DD") +
          " " +
          toRaw(formState).timeEnd.format("HH:mm"),
        user: toRaw(formState).user,
        graphic: true,
      });
      loadingChart.value = false;
    }

    const searchTable = async () => {
      loadingTable.value = true;
      const response = await fetchTypificationsByHour({
        entity: toRaw(formState).entity,
        campaign: toRaw(formState).campaign,
        base: toRaw(formState).base,
        timeStart:
          dateToString(toRaw(formState).date, "yyyy-MM-DD") +
          " " +
          toRaw(formState).timeStart.format("HH:mm"),
        timeEnd:
          dateToString(toRaw(formState).date, "yyyy-MM-DD") +
          " " +
          toRaw(formState).timeEnd.format("HH:mm"),
        user: toRaw(formState).user,
      });
      dataTable.value = response.results;
      countReport.value = response.count;
      loadingTable.value = false;
    }
    const handleSearch = () => {
      searchChart();
      searchTable();      
    };
    const handleChange = (value) => {
      userSelected.value = value;
    };

    const handleOpenChange = (dateValue) => {
      if (dateValue == dayjs().format("YYYY-MM-DD")) {
        formState.timeEnd = dayjs(store.getters["getHourPlatform"], "HH:mm");
      } else {
        formState.timeEnd = dayjs("23:59", "HH:mm");
      }
    };
    const disabledDate = (current) => {
      return current && current >= moment().endOf("day");
    };

    watch(user, (newValue) => {
      if (newValue.customer.type_business == 2) {
        formState.entity.value = 1;
      }
    });

    return {
      formRef,
      formState,
      rules,
      user,
      endOpen,
      isDisabled,
      countReport,
      handleDownload,
      handleSearch,
      moment,
      data,
      dataTable,
      userSelected,
      handleChange,
      columnsTable,
      isLoading,
      handleOpenChange,
      disabledDate,
      isGlobalDownloading,
      countLoading,
      loadingChart,
      loadingTable,
      showEntity,
      showBases,
      countControlsLoading,
    };
  },
  computed: {
    isHideBase() {
      return this.user?.customer?.enable_bases;
    },
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-table-thead > tr > th .ant-table-column-sorter)
  display: none
.selectors
  display: grid
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr
  gap: 15px
  padding: 15px 5px 5px
:deep(.ant-calendar-picker-icon)
  top: 50% !important
:deep(.ant-calendar-picker)
  width: 100%
:deep(.ant-time-picker)
  width: 100%

:deep(.ant-form-item)
  margin-bottom: 0

.back
  display: flex
  align-items: flex-end
  gap: 8px

.totalReport__wrapper
  height: 32px
  flex: 0 0 auto
  display: grid
  place-content: center

.main-text
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: 28px
  letter-spacing: 0em
  text-align: center
  color: $gray-7
.total
  color: $gray-8

.results
  display: flex
  align-items: baseline
  justify-content: flex-end
  margin-top: -40px

.flex
  display: flex
  margin-top: 30px
  position: absolute
  justify-self: flex-end
  align-items: center

.button__download
  padding: 0

.back-base
  display: flex
  align-items: flex-end
  gap: 8px

.chart-placeholder
  padding: 0

.gray-card
  width: 100%
  height: clamp(220px, 38vh, 420px)
  border-radius: 8px
  background: var(--ant-color-fill, #f0f2f5)
  /* fallback para temas sin token */
  background-color: #e9ecef

</style>
